/** Spanish for the records area. Keys are the exact English strings the UI renders. */
const records = {
  'Order history': 'Historial del pedido',
  'Date of birth': 'Fecha de nacimiento',
  'Service dates': 'Fechas de servicio',
  'Master distributor': 'Distribuidor principal',
  'Could not prepare this document.': 'No se pudo preparar este documento.',
  'Retry document': 'Reintentar documento',
  'This record could not be deleted. If it has a linked invoice, deleting anyway will leave that invoice in place.':
    'No se pudo eliminar este registro. Si tiene una factura vinculada, eliminarlo de todos modos dejará esa factura sin cambios.',
  // ── Clinics page: header ──
  Clinics: 'Clínicas',
  'Removed clinics': 'Clínicas quitadas',
  'Clinics are synced from QuickBooks Customers - QuickBooks is the system of record.':
    'Las clínicas se sincronizan desde los clientes de QuickBooks: QuickBooks es el sistema de registro.',
  'Taken out of the list and every picker. Still in QuickBooks, and existing orders keep their clinic.':
    'Quitadas de la lista y de todos los selectores. Siguen en QuickBooks y los pedidos existentes conservan su clínica.',
  'Back to clinics': 'Volver a clínicas',
  'Removed ({count})': 'Quitadas ({count})',
  'Syncing...': 'Sincronizando...',
  'Sync from QuickBooks': 'Sincronizar desde QuickBooks',
  'Synced from QuickBooks: {fetched} customers fetched, {created} new, {updated} updated.':
    'Sincronizado desde QuickBooks: {fetched} clientes obtenidos, {created} nuevos, {updated} actualizados.',
  'Sync failed - is QuickBooks configured?':
    'La sincronización falló. ¿Está configurado QuickBooks?',

  // ── Clinics page: rep assignments ──
  'Rep Assignments': 'Asignaciones de representantes',
  'Pick a sales rep, check the clinics they cover, save. Reps only see and submit for their assigned clinics.':
    'Elija un representante de ventas, marque las clínicas que cubre y guarde. Los representantes solo ven sus clínicas asignadas y solo envían para ellas.',
  'Sales rep': 'Representante de ventas',
  'Select a sales rep...': 'Seleccione un representante de ventas...',
  'No clinics yet - run Sync from QuickBooks first.':
    'Aún no hay clínicas. Ejecute primero «Sincronizar desde QuickBooks».',
  'Saving...': 'Guardando...',
  'Save Assignments': 'Guardar asignaciones',
  'Failed to save assignments': 'No se pudieron guardar las asignaciones',

  // ── Clinics page: rate cell ──
  'Rate for {name}': 'Tarifa de {name}',
  Save: 'Guardar',
  'Failed to save rate': 'No se pudo guardar la tarifa',

  // ── Clinics page: new clinic user ──
  'New Clinic User': 'Nuevo usuario de clínica',
  'A clinic login sees and submits ONLY for its own clinic. Bound to exactly one clinic.':
    'Un inicio de sesión de clínica ve y envía SOLO para su propia clínica. Vinculado a exactamente una clínica.',
  'First name': 'Nombre',
  'Last name': 'Apellido',
  Email: 'Correo electrónico',
  Password: 'Contraseña',
  'Clinic for user': 'Clínica del usuario',
  'Clinic...': 'Clínica...',
  'Creating...': 'Creando...',
  'Create Clinic User': 'Crear usuario de clínica',
  'Clinic user {email} created.': 'Usuario de clínica {email} creado.',
  'Failed to create clinic user': 'No se pudo crear el usuario de clínica',

  // ── Clinics page: clinic login roles ──
  'Clinic Login Roles': 'Roles de inicio de sesión de clínica',
  Owner: 'Propietario',
  User: 'Usuario',
  "sees the whole practice's records and invoices.":
    've los registros y las facturas de todo el consultorio.',
  'sees only their own submissions and no invoices. New logins start as Owner; switch back anytime.':
    've solo sus propios envíos y ninguna factura. Los inicios de sesión nuevos empiezan como Propietario; puede cambiarlo en cualquier momento.',
  'Clinic login': 'Inicio de sesión de clínica',
  'Select a clinic login...': 'Seleccione un inicio de sesión de clínica...',
  'Practice role': 'Rol en el consultorio',
  'Owner (full practice)': 'Propietario (todo el consultorio)',
  'User (own only)': 'Usuario (solo lo propio)',
  'Save Role': 'Guardar rol',
  'Saved.': 'Guardado.',
  'Failed to save role': 'No se pudo guardar el rol',
  'No clinic logins yet - create one below.':
    'Aún no hay inicios de sesión de clínica. Cree uno abajo.',

  // ── Clinics page: table ──
  NAME: 'NOMBRE',
  COMPANY: 'EMPRESA',
  PHONE: 'TELÉFONO',
  STATUS: 'ESTADO',
  PRACTICE: 'PRÁCTICA',
  'RATE ($/UNIT)': 'TARIFA ($/UNIDAD)',
  'LAST SYNCED': 'ÚLTIMA SINCRONIZACIÓN',
  'Is this QuickBooks customer a real medical practice? "Hidden" removes it from every order/IVR picker. Synced bank rows, suppliers, and other non-practices belong Hidden.':
    '¿Es este cliente de QuickBooks un consultorio médico real? «Oculto» lo quita de todos los selectores de pedidos e IVR. Las filas bancarias sincronizadas, los proveedores y otros registros que no son consultorios deben estar ocultos.',
  'Nothing has been removed from the list.': 'No se ha quitado nada de la lista.',
  'No clinics yet. Click "Sync from QuickBooks" to pull the customer list.':
    'Aún no hay clínicas. Haga clic en «Sincronizar desde QuickBooks» para obtener la lista de clientes.',
  Active: 'Activo',
  Inactive: 'Inactivo',
  Practice: 'Consultorio',
  Hidden: 'Oculto',
  Unreviewed: 'Sin revisar',
  'Confirmed as a real practice - click to hide it from every order/IVR picker':
    'Confirmado como consultorio real. Haga clic para ocultarlo de todos los selectores de pedidos e IVR',
  'Hidden from all pickers - click to confirm it as a real practice':
    'Oculto de todos los selectores. Haga clic para confirmarlo como consultorio real',
  'Nobody has ruled on this record yet - click to confirm it as a real practice':
    'Nadie ha revisado este registro todavía. Haga clic para confirmarlo como consultorio real',
  Restore: 'Restaurar',
  'Put this clinic back in the list and the pickers':
    'Volver a poner esta clínica en la lista y en los selectores',
  'Remove from this list and every picker. QuickBooks is not changed and existing orders keep their clinic.':
    'Quitar de esta lista y de todos los selectores. QuickBooks no cambia y los pedidos existentes conservan su clínica.',
  'Remove {name}': 'Quitar {name}',
  'Remove {name} from the clinics list?': '¿Quitar {name} de la lista de clínicas?',
  'It will also disappear from every order and IVR picker. QuickBooks is NOT changed, existing orders keep their clinic, and you can restore it from "Removed".':
    'También desaparecerá de todos los selectores de pedidos e IVR. QuickBooks NO cambia, los pedidos existentes conservan su clínica y puede restaurarla desde «Quitadas».',
  'Failed to remove': 'No se pudo quitar',
  'Failed to restore': 'No se pudo restaurar',
  'Failed to update': 'No se pudo actualizar',
  // Server messages a Clinics admin can hit
  'Clinic not found': 'Clínica no encontrada',
  'User not found': 'Usuario no encontrado',
  'Clinics can only be assigned to a sales_rep user':
    'Las clínicas solo se pueden asignar a un usuario sales_rep',
  'One or more clinic ids do not exist': 'Uno o más identificadores de clínica no existen',
  'A clinic user must be bound to a clinic':
    'Un usuario de clínica debe estar vinculado a una clínica',
  'clinicRole can only be set on a clinic user':
    'clinicRole solo se puede establecer en un usuario de clínica',
  'Email already registered': 'El correo electrónico ya está registrado',

  // ── Register / edit user page ──
  'Register {role}': 'Registrar {role}',
  'Edit {role}': 'Editar {role}',
  'Edit account': 'Editar cuenta',
  'Edit account for {name}': 'Editar cuenta de {name}',
  'Edit user account': 'Editar cuenta de usuario',
  'Update login details or reset the password for this user.':
    'Actualice los datos de acceso o restablezca la contraseña de este usuario.',
  'Add a new {role} to the system.': 'Agregue al sistema un nuevo usuario con el rol de {role}.',
  'Update {role} details.': 'Actualice los datos del usuario con el rol de {role}.',
  'Sales Representative': 'Representante de ventas',
  Admin: 'Administrador',
  Clinic: 'Clínica',
  Patient: 'Paciente',
  'Sees only their own clinics, orders and invoices.':
    'Ve solo sus propias clínicas, pedidos y facturas.',
  'Every screen, including invoicing, statements and user management.':
    'Todas las pantallas, incluidas la facturación, los estados de cuenta y la administración de usuarios.',
  Role: 'Rol',
  'A role cannot be changed here. Create a new login instead.':
    'El rol no se puede cambiar aquí. Cree un nuevo inicio de sesión en su lugar.',
  'First Name': 'Nombre',
  'Last Name': 'Apellido',
  'Enter first name': 'Ingrese el nombre',
  'Enter last name': 'Ingrese el apellido',
  'Enter email': 'Ingrese el correo electrónico',
  '(leave blank to keep existing)': '(déjelo en blanco para conservar la actual)',
  'New password (optional)': 'Nueva contraseña (opcional)',
  'Min 12 chars, A-a-1-!': 'Mín. 12 caracteres, A-a-1-!',
  '12+ chars with uppercase, lowercase, number & special character (@$!%*?&#)':
    '12 o más caracteres con mayúscula, minúscula, número y carácter especial (@$!%*?&#)',
  'Date of Birth': 'Fecha de nacimiento',
  Gender: 'Género',
  'Select gender': 'Seleccione el género',
  Male: 'Masculino',
  Female: 'Femenino',
  Other: 'Otro',
  Address: 'Dirección',
  'Enter address': 'Ingrese la dirección',
  City: 'Ciudad',
  'Enter city': 'Ingrese la ciudad',
  State: 'Estado',
  'Enter state': 'Ingrese el estado',
  'Zip Code': 'Código postal',
  'Enter zip code': 'Ingrese el código postal',
  'Mobile Number': 'Número de celular',
  'Enter mobile number': 'Ingrese el número de celular',
  'License Number': 'Número de licencia',
  'Enter license number': 'Ingrese el número de licencia',
  'Assigned Providers': 'Proveedores asignados',
  'Select Providers': 'Seleccione proveedores',
  'Search providers...': 'Buscar proveedores...',
  'No providers found': 'No se encontraron proveedores',
  Cancel: 'Cancelar',
  'First name, last name, and email are required':
    'El nombre, el apellido y el correo electrónico son obligatorios',
  'Password is required': 'La contraseña es obligatoria',
  'Password must be at least 12 characters': 'La contraseña debe tener al menos 12 caracteres',
  'Password must include uppercase, lowercase, number, and special character (@$!%*?&#)':
    'La contraseña debe incluir mayúscula, minúscula, número y carácter especial (@$!%*?&#)',
  'Date of Birth must be in MM/DD/YYYY format':
    'La fecha de nacimiento debe tener el formato MM/DD/AAAA',
  'Failed to load user': 'No se pudo cargar el usuario',
  'Failed to save user': 'No se pudo guardar el usuario',
  'User updated successfully!': '¡Usuario actualizado correctamente!',
  '{role} created successfully! Share these credentials with them: Email — {email} / Password — {password}':
    '¡Cuenta de {role} creada correctamente! Comparta estas credenciales con la persona: Correo electrónico — {email} / Contraseña — {password}',

  // ── Providers (doctors) page ──
  Providers: 'Proveedores',
  'List of providers': 'Lista de proveedores',
  '+ Add Provider': '+ Agregar proveedor',
  'Add Provider': 'Agregar proveedor',
  'Edit Provider': 'Editar proveedor',
  'Fill the provider details': 'Complete los datos del proveedor',
  'Practice Name': 'Nombre del consultorio',
  'Enter practice name': 'Ingrese el nombre del consultorio',
  'PROVIDER NAME': 'NOMBRE DEL PROVEEDOR',
  'PRACTICE NAME': 'NOMBRE DE LA PRÁCTICA',
  ADDRESS: 'DIRECCIÓN',
  ACTIONS: 'ACCIONES',
  Edit: 'Editar',
  Delete: 'Eliminar',
  'N/A': 'N/A',
  'Delete {name}?': '¿Eliminar a {name}?',
  'First name, last name, and practice name are required':
    'El nombre, el apellido y el nombre del consultorio son obligatorios',
  'Failed to save provider': 'No se pudo guardar el proveedor',
  'Failed to delete provider': 'No se pudo eliminar el proveedor',
  'Doctor not found': 'Médico no encontrado',

  // ── Products page ──
  Products: 'Productos',
  'Manage your product catalog.': 'Administre su catálogo de productos.',
  'Search products...': 'Buscar productos...',
  '+ Add Product': '+ Agregar producto',
  'Add Products': 'Agregar productos',
  'Edit Product': 'Editar producto',
  'Product Name': 'Nombre del producto',
  'Enter product name': 'Ingrese el nombre del producto',
  'Enter SKU': 'Ingrese el SKU',
  Category: 'Categoría',
  'Enter category': 'Ingrese la categoría',
  Price: 'Precio',
  'Enter price': 'Ingrese el precio',
  'Stock Quantity': 'Cantidad en existencia',
  'PRODUCT NAME': 'NOMBRE DEL PRODUCTO',
  CATEGORY: 'CATEGORÍA',
  PRICE: 'PRECIO',
  STOCK: 'EXISTENCIAS',
  'No products found': 'No se encontraron productos',
  'Delete Product': 'Eliminar producto',
  'Are you sure you want to delete': '¿Está seguro de que desea eliminar',
  '? This action cannot be undone.': '? Esta acción no se puede deshacer.',
  'Product name, SKU, and category are required':
    'El nombre del producto, el SKU y la categoría son obligatorios',
  'Failed to save product': 'No se pudo guardar el producto',
  'SKU already exists': 'El SKU ya existe',
  'Product not found': 'Producto no encontrado',

  'Could not confirm whether the user was created. Refresh the user list before trying again.':
    'No se pudo confirmar si se creó el usuario. Actualice la lista de usuarios antes de intentarlo de nuevo.',

  // Same in both languages (listed in SAME_IN_BOTH in es.test.js).
  SKU: 'SKU',
};

export default records;
